import React from "react";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../helper/Preloader";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import BreadcrumbImage from "../components/BreadcrumbImage";
import WhyGetFunCard from "../components/WhyGetFunCard";
import CounterSection from "../components/CounterSection";
import TutorialStepsSection from "../components/TutorialStepsSection";
import TestimonialOne from "../components/TestimonialOne";
import ShippingOne from "../components/ShippingOne";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";

const TutorialPage = () => {
  return (
    <>
      <ColorInit color={true} />
      <ScrollToTop smooth color='#FA6400' />
      <Preloader />
      <HeaderTwo category={true} />
      <Breadcrumb title={"How It Works"} />
      <BreadcrumbImage
        heading="Become a Fun Card Holder"
        subtext="18 Years of Coupon Deals, 10,000+ Happy Customers."
        buttonText="Create a User Account"
        buttonLink="/account-login"
        accent="right"
      />
      <WhyGetFunCard />
      <CounterSection />
      <TutorialStepsSection />
      {/* <section className='pb-120'>
        <TestimonialOne />
      </section> */}
      <ShippingOne />
      <FooterTwo />
      <BottomFooter />
    </>
  );
};

export default TutorialPage;
